import connector from '../../connector.js'

/**
 * Request password reset email
 * @param {Object} options
 * @param {string} options.username Send an email to this user
 */
export function getToken({ username }) {
  return connector.post('auth/password-reset/get-token', { username })
}

/**
 * Set new password with a token
 * @param {Object} options
 * @param {string} options.token Password reset token
 * @param {string} options.newPassword New password
 * @param {string} options.newPasswordRetype New password again
 */
export function useToken({ token, newPassword: password, newPasswordRetype: passwordRetype }) {
  return connector.post('auth/password-reset/use-token', {
    token,
    password,
    password_retype: passwordRetype
  })
}

/**
 * Check token validity
 * @param {Object} options
 * @param {string} options.token Password reset token
 */
export function verifyToken({ token }) {
  return connector.post('auth/password-reset/verify-token', { token })
}
